import $ from "jquery";
import TemplateView from "../../TemplateView";
import Tooltip from "../../Tooltip";
import {Feature, isEnabled} from "../../features/index";

class InfoTooltip extends Tooltip {
    templateHtml() {
        return "<div class='importTasksInfoTooltip'>" +
               "  <div><%-header%></div>" +
               "  <ul>" +
               "    <li><%-taskNames%></li>" +
               "    <% if (est) {%>" +
               "    <li><%-estimatedHours%></li>" +
               "    <%}%>" +
               "    <% if (bty) {%>" +
               "    <li><%-billingTypes%></li>" +
               "    <%}%>" +
               "    <li><%-descriptions%></li>" +
               "  </ul>" +
               "  <div><b><%-footer%></b></div>" +
               "</div>"
    }

    messageKeys() {
        return {
            header: 'add_new_tasks.import_tasks_tooltip_info_header',
            taskNames: 'add_new_tasks.import_tasks_tooltip_info_task_names',
            estimatedHours: 'add_new_tasks.import_tasks_tooltip_info_estimated_hours',
            billingTypes: 'add_new_tasks.import_tasks_tooltip_info_billing_types',
            descriptions: 'add_new_tasks.import_tasks_tooltip_info_descriptions',
            footer: 'add_new_tasks.import_tasks_tooltip_info_footer'
        }
    }

    templateModel() {
        return {
            est: isEnabled(Feature.EST),
            bty: isEnabled(Feature.BTY)
        }
    }
}

let infoTooltip = null;
function getInfoTooltip() {
    if (!infoTooltip) {
        infoTooltip = new InfoTooltip().init($("body"));
    }
    return infoTooltip;
}

export default class ImportTasksSelectorButton extends TemplateView {
    constructor(onClick = () => {}) {
        super();
        this.onClick = onClick;
    }

    templateHtml() {
        return '<div class="importTasksSelectorButton">' +
               '  <div class="importIcon"></div>' +
               '  <div class="title dashedLink"><%-title%></div>' +
               '  <div class="infoIcon"></div>' +
               '</div>'
    }

    afterRender() {
        this.$el.click(() => this.onClick());
        getInfoTooltip().subscribeToMouseEvents(this.find(".infoIcon"));
    }

    messageKeys() {
        return {
            title: 'task_selector.importTasksButton'
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/ImportTasksSelectorButton.js